export default function hasEmoji(str: string) {
  const emojiRegex = /[\uD83C-\uDBFF\uDC00-\uDFFF]/gu
  return emojiRegex.test(str)
}
